const initImageAccordion = () => {
    const accordionTogglerList = Array.from(document.querySelectorAll("[data-accordion-toggler]"));
    if (accordionTogglerList && accordionTogglerList.length > 0) {
        const imageElement = document.querySelector("[data-img]");
        let urlSrc;
        let imageAlt;
        const setImage = (inputItem, outputItem) => {
            urlSrc = inputItem.getAttribute("data-src");
            imageAlt = inputItem.getAttribute("data-alt");
            outputItem.setAttribute("src", urlSrc);
            outputItem.setAttribute("alt", imageAlt);
        };
        for (let index = 0; index < accordionTogglerList.length; index++) {
            const toggler = accordionTogglerList[index];
            const description = toggler.parentElement.querySelector("[data-height-to-toggle]");
            //get description height
            const height = parseInt((description.getBoundingClientRect().height + 25).toString());
            //set height to data-attribute to use it on active accordion content
            description.setAttribute("data-height-to-toggle", height.toString());
            //set content height to 0
            description.style.height = "0";
            if (index === 0) {
                toggler.classList.add("active");
                setImage(toggler, imageElement);
            }
            //bind a click event
            toggler.addEventListener("click", () => {
                accordionTogglerList.filter(x => x != toggler).forEach(x => {
                    //deactivate all elements but the one clicked
                    x.classList.remove("active");
                    const y = x.parentElement.querySelector("[data-height-to-toggle]");
                    y.style.height = "0";
                });
                if (!toggler.classList.contains("active")) {
                    //add class active
                    toggler.classList.toggle("active");
                    //add height to content
                    description.style.height = `${description.getAttribute("data-height-to-toggle")}px`;
                    setImage(toggler, imageElement);
                }
                else {
                    //remove class active
                    toggler.classList.remove("active");
                    //add height to content
                    description.style.height = "0";
                }
            });
        }
    }
};
